import { Link } from 'react-router-dom'
import PolicyPage, { PolicySection, PolicyList } from 'components/compliance/policy-page'
import compliance from 'data/compliance.json'

const { organisation, admissions } = compliance

function AdmissionsDisclaimer() {
  return (
    <PolicyPage
      title='Admission, Scholarship and Visa Disclaimer'
      description='UHDSS provides counselling and application support. Admission, scholarship and visa decisions are made by institutions and government authorities, not by UHDSS.'
      intro={admissions.shortDisclaimer}
    >
      <PolicySection title='What we do'>
        <p className='dark-blue fs-6'>
          {organisation.legalName}, referred to here as UHDSS, provides education counselling,
          application guidance and student support. We help you understand your options, prepare
          your documents and submit applications to the institutions you choose.
        </p>
      </PolicySection>

      <PolicySection title='Admission and scholarship decisions'>
        <p className='dark-blue fs-6'>
          UHDSS does not make admission, academic assessment, scholarship or offer decisions on
          behalf of universities, colleges or other education institutions. All of these decisions
          remain with the institution you apply to.
        </p>
        <p className='dark-blue fs-6'>
          Receiving counselling or application support from UHDSS does not guarantee admission, an
          offer letter, a scholarship, a particular scholarship amount, or enrolment.
        </p>
      </PolicySection>

      <PolicySection title='Visa decisions'>
        <p className='dark-blue fs-6'>
          UHDSS can help you understand visa requirements, organise your documents and complete the
          steps of an application. UHDSS does not make immigration or visa decisions. Those
          decisions are made only by the relevant embassy, consulate, immigration authority or
          government department, and UHDSS cannot guarantee that a visa will be approved.
        </p>
        <p className='dark-blue fs-6'>
          We will always refer you to the official institution or government website for the
          requirements that apply to your case, because those sources are the ones that count.
        </p>
      </PolicySection>

      <PolicySection title='No guarantees of outcome'>
        <p className='dark-blue fs-6'>
          Every admission and visa application is assessed individually by the responsible
          institution or authority. Outcomes reached by other applicants do not predict or
          guarantee the result of your application. We do not publish success rates, and we do not
          promise a particular result.
        </p>
      </PolicySection>

      <PolicySection title='Before we recommend an application'>
        <p className='dark-blue fs-6'>
          We look at your circumstances before we suggest an institution or a programme. Depending
          on the destination and the course, this may include:
        </p>
        <PolicyList items={admissions.suitabilityFactors} />
        <p className='dark-blue fs-6'>
          This is our guidance, based on the information you give us and on what we know at the
          time. It is not a formal decision, and it does not replace the assessment made by the
          university or by the immigration authority.
        </p>
        <p className='dark-blue fs-6'>
          You can read more about how we work with you in our{' '}
          <Link className='text-decoration-none' to='/student-commitment'>Student Commitment and Counselling Charter</Link>.
        </p>
      </PolicySection>
    </PolicyPage>
  )
}

export default AdmissionsDisclaimer
